var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlockUtglWeb = function SvgUnlockUtglWeb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.389 14.88V7.063H1.619v7.825h10.77v-.008Zm-1.37-8.922h.435l2.046-.024v10.058H.5V5.942h2.48V4.115C2.98 1.772 4.705 0 6.985 0c1.78 0 3.246 1.08 3.802 2.677l-1.015.397c-.387-1.191-1.434-1.97-2.78-1.97-1.707 0-2.899 1.263-2.899 3.011v1.827h5.84l1.087.016ZM6.46 13.021v-2.169c-.298-.143-.491-.485-.491-.866a1.038 1.038 0 1 1 2.078 0c0 .381-.193.723-.523.914l.024 2.12H6.46Z",
    fill: "#DC9B32"
  })));
};
export default SvgUnlockUtglWeb;